interface HeaderProps {
  isMobile: boolean;
  onMenuToggle: () => void;
}

function scrollOrNavigate(selector: string) {
  const section = document.querySelector(selector);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  } else {
    window.location.href = '/' + (selector === '[data-what-is-section]' ? '#about' : selector === '[data-download-section]' ? '#download' : '');
  }
}

function Header({ isMobile, onMenuToggle }: HeaderProps) {
  const s = styles(isMobile);
  const isHome = window.location.pathname === '/' || window.location.pathname === '/download';

  return (
    <header style={s.header}>
      <div style={s.headerContent}>
        <a
          style={s.logoContainer}
          href="/"
          onClick={(e) => {
            if (isHome) {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          <img
            src="https://static.storm-byte.dev/logo.png"
            alt="Hereabout Logo"
            style={s.logo}
          />
        </a>

        {/* Desktop Nav */}
        <nav style={s.nav}>
          <a
            style={s.navLink}
            href="/"
            onClick={(e) => {
              if (isHome) {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#dc2626')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#64748b')}
          >
            Home
          </a>
          <a
            style={s.navLink}
            href="/#download"
            onClick={(e) => {
              if (isHome) {
                e.preventDefault();
                scrollOrNavigate('[data-download-section]');
              }
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#dc2626')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#64748b')}
          >
            Download
          </a>
          <a
            style={s.navLink}
            href="/blog"
            onMouseEnter={(e) => (e.currentTarget.style.color = '#dc2626')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#64748b')}
          >
            Blog
          </a>
        </nav>

        {/* Mobile Hamburger */}
        <div style={s.hamburger} onClick={onMenuToggle}>
          <div style={s.hamburgerLine}></div>
          <div style={s.hamburgerLine}></div>
          <div style={s.hamburgerLine}></div>
        </div>
      </div>
    </header>
  );
}

export default Header;

const styles = (isMobile?: boolean) => ({
  header: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    padding: isMobile ? '8px 16px' : '16px 20px',
  },

  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
  },

  logo: {
    height: isMobile ? '32px' : '40px',
    width: isMobile ? '32px' : '40px',
  },

  logoText: {
    fontSize: isMobile ? '1.1rem' : '1.3rem',
    fontWeight: '700',
    color: '#fc2c03',
    letterSpacing: '-0.02em',
  },

  nav: {
    display: isMobile ? 'none' : 'flex',
    gap: '32px',
    alignItems: 'center',
  },

  navLink: {
    color: '#64748b',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '0.95rem',
    transition: 'color 0.3s ease',
    cursor: 'pointer',
  },

  hamburger: {
    display: isMobile ? 'flex' : 'none',
    flexDirection: 'column' as const,
    gap: '5px',
    cursor: 'pointer',
    padding: '8px',
  },

  hamburgerLine: {
    width: '24px',
    height: '2px',
    background: '#64748b',
    borderRadius: '2px',
    transition: 'all 0.3s ease',
  },
});
